import { render, staticRenderFns } from "./BuildingDetail.vue?vue&type=template&id=28461b46&scoped=true&"
import script from "./BuildingDetail.vue?vue&type=script&lang=js&"
export * from "./BuildingDetail.vue?vue&type=script&lang=js&"
import style0 from "./BuildingDetail.vue?vue&type=style&index=0&id=28461b46&lang=scss&scoped=true&"
import style1 from "./BuildingDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28461b46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28461b46')) {
      api.createRecord('28461b46', component.options)
    } else {
      api.reload('28461b46', component.options)
    }
    module.hot.accept("./BuildingDetail.vue?vue&type=template&id=28461b46&scoped=true&", function () {
      api.rerender('28461b46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/settings/BuildingDetail.vue"
export default component.exports